//当前这个模块：API进行统一管理
import requests from './request';
//发送邮箱验证码注册用户
export const sendEmail= ({data}) =>{
return requests({url:'/api/email',data,method:'post'})
}
//注册用户
export const reqRegister= (data) =>{
return requests({url:'/api/reguser',data,method:'post'})
}
//发送邮箱验证码重置密码
export const sendResetEmail= ({data}) =>{
return requests({url:'/api/resetemail',data,method:'post'})
}
//重置密码
export const resetEmailPassword= (data) =>{
return requests({url:'/api/resetpassword',data,method:'put'})
}

//登录
export const reqLogin= (data) =>{
return requests({url:'/api/login',data,method:'post'})
}
/*首页*/
//获取首页信息
export const getHomeList= () =>{
return requests({url:'/web/home',method:'get'})
}
//新增信息
export const addHomeData= ({data}) =>{
return requests({url:'/web/home/add',data,method:'post'})
}
//根据id获取信息
export const byIdHome= (id) =>{
return requests({url:`/web/home/byid/${id}`,method:'get'})
}
//根据id更新数据
export const updateByHome= ({data}) =>{
return requests({url:'/web/home/update',data,method:'put'})
}
//删除数据
export const delHome= (id) =>{
return requests({url:`/web/home/delete/${id}`,method:'delete'})
}
/*首页分类信息*/
//获取所有分类信息
export const getHomeCateAll= ({params}) =>{
return requests({url:'/manage/homecateall',params,method:'get'})
}
//根据男女分类获取不同信息
export const getHomeCate= (id) =>{
return requests({url:`/manage/homecate/${id}`,method:'get'})
}
//新增信息
export const addHomeCateData= ({data}) =>{
return requests({url:'/manage/homecate/add',data,method:'post'})
}
//根据id获取信息
export const byIdHomeCate= (id) =>{
return requests({url:`/manage/homecate/byid/${id}`,method:'get'})
}
//根据id更新数据
export const updateByHomeCate= ({data}) =>{
return requests({url:'/manage/homecate/update',data,method:'put'})
}
//删除数据
export const delHomeCate= (id) =>{
return requests({url:`/manage/homecate/delete/${id}`,method:'delete'})
}
/*个人中心*/
//获取用户基本信息
export const getuserinfo= () =>{
return requests({url:'/my/userinfo',method:'get'})
}
//更新用户信息
export const updataUserInfo= (data) =>{
return requests({url:'/my/userinfo',data,method:'post'})
}
//更新用户审核信息
export const updataUserInfoSh= (data) =>{
return requests({url:'/my/userinfosh',data,method:'post'})
}
//更换头像
export const avatar = ({data}) =>{
return requests({url:'/my/update/avatar',data,method:'post'})
}
//修改密码
export const changePassword = (data) =>{
return requests({url:'/my/updatepwd',data,method:'post'})
}

//添加用户和编辑用户时返回的客服和销售
//选择客服
export const getMyCustomer = () =>{
return requests({url:'/api/customer',method:'get'})
}
//选择销售
export const getMySales = () =>{
return requests({url:'/api/sales',method:'get'})
}
//选择角色
export const getMyRole = () =>{
return requests({url:'/api/role',method:'get'})
}


//保存用户查询海运整箱历史查询
export const saveFclQueryHistory= ({data}) =>{
return requests({url:`/my/savefcl`,data,method:'put'})
}
//保存用户查询海运拼箱历史查询
export const saveLclQueryHistory= ({data}) =>{
return requests({url:`/my/savelcl`,data,method:'put'})
}
//保存用户内陆拖车历史查询
export const saveTrailerQueryHistory= ({data}) =>{
return requests({url:`/my/savetrailer`,data,method:'put'})
}
//保存用户空运历史查询
export const saveByAirQueryHistory= ({data}) =>{
return requests({url:`/my/savebyair`,data,method:'put'})
}

//保存用户铁路历史查询
export const saveRailroadQueryHistory= ({data}) =>{
return requests({url:`/my/saverailroad`,data,method:'put'})
}

//保存用户国际快递历史查询
export const saveExpressQueryHistory= ({data}) =>{
return requests({url:`/my/saveexpress`,data,method:'put'})
}
//----------------------------------------------------------------------------
/*菜单路由*/
//获取不同的菜单路由
export const getMenu= () =>{
return requests({url:'/my/myMenu',method:'get'})
}
//所有菜单栏信息
export const getAllMenu= () =>{
return requests({url:'/my/allMenu',method:'get'})
}
//新增菜单栏
export const addMenu= ({data}) =>{
return requests({url:'/my/addmenu',data,method:'post'})
}
//根据id获取菜单栏信息
export const byIdGetMenu= (id) =>{
return requests({url:`/my/byidmenu/${id}`,method:'get'})
}
//编辑菜单栏信息
export const editMenu= ({data}) =>{
return requests({url:'/my/editmenu',data,method:'put'})
}
//删除菜单栏
export const delMenu= (id) =>{
return requests({url:`/my/deletemenu/${id}`,method:'delete'})
}
/*用户列表*/
//获取用户列表
export const getuserList= ({params}) =>{
return requests({url:'/my/userlist',params,method:'get'})
}
//保存用户所选的角色
export const saveroles= ({data}) =>{
return requests({url:'/my/saverole',data,method:'post'})
}
//根据id获取用户信息
export const byIduser= (id) =>{
return requests({url:`/my/byiduser/${id}`,method:'get'})
}
//编辑用户表单
export const editUser= ({data}) =>{
return requests({url:'/my/edituser',data,method:'put'})
}
//删除用户
export const delUser= (id) =>{
return requests({url:`/my/deluser/${id}`,method:'delete'})
}
//更新用户状态
export const updateState= ({data}) =>{
return requests({url:'/my/updatestate',data,method:'put'})
}
//保存用户所选的视图
export const saveView= ({data}) =>{
return requests({url:'/my/saveview',data,method:'post'})
}
//审核用户状态
export const AuditUserState= ({data}) =>{
return requests({url:'/my/audituser',data,method:'put'})
}
//审核信息资料用户
export const AuditShZlUser= ({data}) =>{
return requests({url:'/my/auditshzluser',data,method:'put'})
}
//获取新用户待审核数目
export const getDshAuditShZlUser= () =>{
return requests({url:'/my/getzcaudituser',method:'get'})
}

//分配用户等级
export const saveUserLevelRights= ({data}) =>{
return requests({url:'/my/saveuserlevel',data,method:'post'})
}
//后台添加用户
export const addUserData= (data) =>{
return requests({url:'/my/adduserdata',data,method:'post'})
}

//离职交接，获取可交接人员列表
export const getHandOverList= (id) =>{
return requests({url:`/my/getHandOverList/${id}`,method:'get'})
}

//离职交接，获取可交接人员列表
export const confirmHandOver= ({data}) =>{
return requests({url:`/my/confirmHandOver`,data,method:'put'})
}


/*角色列表*/
//获取角色树形结构
export const getrolesTreeList= () =>{
return requests({url:'/my/rolestreelist',method:'get'})
}

//获取角色列表
export const getrolesList= () =>{
return requests({url:'/my/roleslist',method:'get'})
}
//新增角色
export const addroles= (data) =>{
return requests({url:'/my/addroles',data,method:'post'})
}
//根据id获取角色信息
export const byIdroles= (id) =>{
return requests({url:`/my/byidroles/${id}`,method:'get'})
}
//编辑角色信息
export const editRoles= (data) =>{
return requests({url:'/my/editroles',data,method:'put'})
}
//删除角色信息
export const delRoles= (id) =>{
return requests({url:`/my/delroles/${id}`,method:'delete'})
}
//保存角色所选的菜单权限权力
export const savePowerRoles= ({data}) =>{
return requests({url:'/my/saverightsroles',data,method:'post'})
}

/*********************************首页特惠航线**********************************/
//海运整箱
export const getSpecialFclSaleList= () =>{
return requests({url:'/nopermission/getspecialfclsale',method:'get'})
}
export const saveSpecialFclSale= (data) =>{
return requests({url:'/my/savespecialfclsale',data,method:'post'})
}
export const delSpecialFclSale= (id) =>{
return requests({url:`/my/delspecialfclsale/${id}`,method:'delete'})
}
export const byIdSpecialFclSale= (id) =>{
return requests({url:`/my/byidspecialfclsale/${id}`,method:'get'})
}
export const editSpecialFclSale= (data) =>{
return requests({url:'/my/editspecialfclsale',data,method:'put'})
}

//海运拼箱
export const getSpecialLclSaleList= () =>{
return requests({url:'/nopermission/getspeciallclsale',method:'get'})
}
export const saveSpecialLclSale= (data) =>{
return requests({url:'/my/savespeciallclsale',data,method:'post'})
}
export const delSpecialLclSale= (id) =>{
return requests({url:`/my/delspeciallclsale/${id}`,method:'delete'})
}
export const byIdSpecialLclSale= (id) =>{
return requests({url:`/my/byidspeciallclsale/${id}`,method:'get'})
}
export const editSpecialLclSale= (data) =>{
return requests({url:'/my/editspeciallclsale',data,method:'put'})
}

//内陆拖车
export const getSpecialTrailerSaleList= () =>{
return requests({url:'/nopermission/getspecialtrailersale',method:'get'})
}
export const saveSpecialTrailerSale= (data) =>{
return requests({url:'/my/savespecialtrailersale',data,method:'post'})
}
export const delSpecialTrailerSale= (id) =>{
return requests({url:`/my/delspecialtrailersale/${id}`,method:'delete'})
}
export const byIdSpecialTrailerSale= (id) =>{
return requests({url:`/my/byidspecialtrailersale/${id}`,method:'get'})
}
export const editSpecialTrailerSale= (data) =>{
return requests({url:'/my/editspecialtrailersale',data,method:'put'})
}

//空运
export const getSpecialByAirSaleList= () =>{
return requests({url:'/nopermission/getspecialbyairsale',method:'get'})
}
export const saveSpecialByAirSale= (data) =>{
return requests({url:'/my/savespecialbyairsale',data,method:'post'})
}
export const delSpecialByAirSale= (id) =>{
return requests({url:`/my/delspecialbyairsale/${id}`,method:'delete'})
}
export const byIdSpecialByAirSale= (id) =>{
return requests({url:`/my/byidspecialbyairsale/${id}`,method:'get'})
}
export const editSpecialByAirSale= (data) =>{
return requests({url:'/my/editspecialbyairsale',data,method:'put'})
}


//铁路
export const getSpecialRailRoadSaleList= () =>{
return requests({url:'/nopermission/getspecialrailroadsale',method:'get'})
}
export const saveSpecialRailRoadSale= (data) =>{
return requests({url:'/my/savespecialrailroadsale',data,method:'post'})
}
export const delSpecialRailRoadSale= (id) =>{
return requests({url:`/my/delspecialrailroadsale/${id}`,method:'delete'})
}
export const byIdSpecialRailRoadSale= (id) =>{
return requests({url:`/my/byidspecialrailroadsale/${id}`,method:'get'})
}
export const editSpecialRailRoadSale= (data) =>{
return requests({url:'/my/editspecialrailroadsale',data,method:'put'})
}

//国际快递
export const getSpecialExpressSaleList= () =>{
return requests({url:'/nopermission/getspecialexpresssale',method:'get'})
}
export const saveSpecialExpressSale= (data) =>{
return requests({url:'/my/savespecialexpresssale',data,method:'post'})
}
export const delSpecialExpressSale= (id) =>{
return requests({url:`/my/delspecialexpresssale/${id}`,method:'delete'})
}
export const byIdSpecialExpressSale= (id) =>{
return requests({url:`/my/byidspecialexpresssale/${id}`,method:'get'})
}
export const editSpecialExpressSale= (data) =>{
return requests({url:'/my/editspecialexpresssale',data,method:'put'})
}







/*******查询价格日志***********************************************************/
//海运整箱
export const getFclLogsList= ({params}) =>{
return requests({url:'/logs/fclloglist',params,method:'get'})
}
//海运拼箱
export const getLclLogsList= ({params}) =>{
return requests({url:'/logs/lclloglist',params,method:'get'})
}
//内陆拖车
export const getTrailerLogsList= ({params}) =>{
return requests({url:'/logs/trailerloglist',params,method:'get'})
}
//空运
export const getByAirLogsList= ({params}) =>{
return requests({url:'/logs/byairloglist',params,method:'get'})
}
//铁路
export const getRailroadList= ({params}) =>{
return requests({url:'/logs/railroadloglist',params,method:'get'})
}
//国际快递
export const getExpressLogsList= ({params}) =>{
return requests({url:'/logs/expressloglist',params,method:'get'})
}
//**************************************************————————————————————————————————————————————————
// 数字字典
//******************************
// 港口数据
//******************海运港口************************
export const getPort= ({params}) =>{
return requests({url:'/data/port',params,method:'get'})
}
export const AddPort= (data) =>{
return requests({url:'/data/addport',data,method:'post'})
}

export const byIdPort= (id) =>{
return requests({url:`/data/port/${id}`,method:'get'})
}

export const editPort= (data) =>{
return requests({url:'/data/updateport',data,method:'put'})
}

export const delPort= (id) =>{
return requests({url:`/data/deleteport/${id}`,method:'delete'})
}
//批量删除
export const delBatchPort= ({id}) =>{
return requests({url:`/data/deletebatchport/${id}`,method:'delete'})
}

export const addMorePort= ({data}) =>{
return requests({url:'/data/addmoreport',data,timeout: 600000,method:'post'})
}
//导出所有数据
export const exportPort= () =>{
return requests({url:'/data/exportport',method:'get'})
}

//查找查询海运港口英文名前位置是否包含空格
export const getCheckPortQian= () =>{
return requests({url:'/data/checkportqian',method:'get'})
}
//查找查询海运港口英文名后位置是否包含空格
export const getCheckPortHou= () =>{
return requests({url:'/data/checkporthou',method:'get'})
}
//匹配港口
export const getCheckPortFcl= () =>{
return requests({url:'/data/checkfclport',method:'get'})
}
export const getPortCheckLcl= () =>{
return requests({url:'/data/checklclport',method:'get'})
}
//*********************空运港口****************
export const getAirPort= ({params}) =>{
return requests({url:'/data/airport',params,method:'get'})
}
export const AddAirPort= (data) =>{
return requests({url:'/data/addairport',data,method:'post'})
}

export const byIdAirPort= (id) =>{
return requests({url:`/data/airport/${id}`,method:'get'})
}

export const editAirPort= (data) =>{
return requests({url:'/data/updateairport',data,method:'put'})
}

export const delAirPort= (id) =>{
return requests({url:`/data/deleteairport/${id}`,method:'delete'})
}
//批量删除
export const delBatchAirPort= ({id}) =>{
return requests({url:`/data/deletebatchairport/${id}`,method:'delete'})
}

export const addMoreAirPort= ({data}) =>{
return requests({url:'/data/addmoreairport',data,timeout: 600000,method:'post'})
}

//导出所有数据
export const exportAirPort= () =>{
return requests({url:'/data/exportairport',method:'get'})
}


//查找查询空运港口代码前位置是否包含空格
export const getCheckAirPortQian= () =>{
return requests({url:'/data/checkairportqian',method:'get'})
}
//查找查询空运港口代码后位置是否包含空格
export const getCheckAirPortHou= () =>{
return requests({url:'/data/checkairporthou',method:'get'})
}
//国际国家快递
export const getExpress= ({params}) =>{
return requests({url:'/data/express',params,method:'get'})
}
export const AddExpress= (data) =>{
return requests({url:'/data/addexpress',data,method:'post'})
}

export const byIdExpress= (id) =>{
return requests({url:`/data/express/${id}`,method:'get'})
}

export const editExpress= (data) =>{
return requests({url:'/data/updateexpress',data,method:'put'})
}

export const delExpress= (id) =>{
return requests({url:`/data/deleteexpress/${id}`,method:'delete'})
}
//批量删除
export const delBatchExpress= ({id}) =>{
return requests({url:`/data/deletebatchexpress/${id}`,method:'delete'})
}

export const addMoreExpress= ({data}) =>{
return requests({url:'/data/addmoreexpress',data,timeout: 600000,method:'post'})
}

//导出所有数据
export const exportExpress= () =>{
return requests({url:'/data/exportexpress',method:'get'})
}





//******************查价数据库*******************************
//海运整箱
export const getFclBySea= ({params}) =>{
return requests({url:'/data/fclbysea',params,method:'get'})
}
export const addMoreFcl= ({data}) =>{
return requests({url:'/data/addmorefcl',data,timeout: 600000,method:'post'})
}
//获取行信息
export const byIdFcl= (id) =>{
return requests({url:`/data/fcl/${id}`,method:'get'})
}
//修改
export const editFcl= (data) =>{
return requests({url:'/data/editfcl',data,method:'put'})
}



export const delFclBySea= (id) =>{
return requests({url:`/data/deletefclbysea/${id}`,method:'delete'})
}
//批量删除
export const delBatchFclBySea= ({id}) =>{
return requests({url:`/data/deletebatchfclbysea/${id}`,method:'delete'})
}


//海运拼箱
export const getLclBySea= ({params}) =>{
return requests({url:'/data/lclbysea',params,method:'get'})
}
export const addMoreLcl= ({data}) =>{
return requests({url:'/data/addmorelcl',data,timeout: 600000,method:'post'})
}

//获取行信息
export const byIdLcl= (id) =>{
return requests({url:`/data/lcl/${id}`,method:'get'})
}
//修改
export const editLcl= (data) =>{
return requests({url:'/data/editlcl',data,method:'put'})
}


export const delLclBySea= (id) =>{
return requests({url:`/data/deletelclbysea/${id}`,method:'delete'})
}
//批量删除
export const delBatchLclBySea= ({id}) =>{
return requests({url:`/data/deletebatchlclbysea/${id}`,method:'delete'})
}

//空运
export const getByAir= ({params}) =>{
return requests({url:'/data/byair',params,method:'get'})
}
export const addMoreByAir= ({data}) =>{
return requests({url:'/data/addmorebyair',data,timeout: 600000,method:'post'})
}
export const addMoreByAirPt= ({data}) =>{
return requests({url:'/data/addmorebyairpt',data,timeout: 600000,method:'post'})
}

export const delByAir= (id) =>{
return requests({url:`/data/deletebyair/${id}`,method:'delete'})
}
//批量删除
export const delBatchByAir= ({id}) =>{
return requests({url:`/data/deletebatchbyair/${id}`,method:'delete'})
}


//内陆拖车
export const getByTrailer= ({params}) =>{
return requests({url:'/data/bytrailer',params,method:'get'})
}
export const addMoreTrailer= ({data}) =>{
return requests({url:'/data/addmoretrailer',data,timeout: 600000,method:'post'})
}
export const delTrailer= (id) =>{
return requests({url:`/data/deletetrailer/${id}`,method:'delete'})
}
export const delBatchTrailer= ({id}) =>{
return requests({url:`/data/deletebatchtrailer/${id}`,method:'delete'})
}
//获取行信息
export const byIdTrailer= (id) =>{
return requests({url:`/data/trailer/${id}`,method:'get'})
}
//修改
export const editTrailer= (data) =>{
return requests({url:'/data/edittrailer',data,method:'put'})
}

//铁路
export const getByRailRoad= ({params}) =>{
return requests({url:'/data/byrailroad',params,method:'get'})
}
export const addMoreRailRoad= ({data}) =>{
return requests({url:'/data/addmorerailroad',data,timeout: 600000,method:'post'})
}
export const delRailRoad= (id) =>{
return requests({url:`/data/deleterailroad/${id}`,method:'delete'})
}
export const delBatchRailRoad= ({id}) =>{
return requests({url:`/data/deletebatchrailroad/${id}`,method:'delete'})
}

//获取行信息
export const byIdRailRoad= (id) =>{
return requests({url:`/data/railroad/${id}`,method:'get'})
}
//修改
export const editRailRoad= (data) =>{
return requests({url:'/data/editrailroad',data,method:'put'})
}


//国际快递数据库
export const getByExpressData= ({params}) =>{
return requests({url:'/data/byexpressdata',params,method:'get'})
}
export const addMoreExpressData= ({data}) =>{
return requests({url:'/data/addmoreexpressdata',data,timeout: 600000,method:'post'})
}
export const delExpressData= (id) =>{
return requests({url:`/data/deleteexpressdata/${id}`,method:'delete'})
}
export const delBatchExpressData= ({id}) =>{
return requests({url:`/data/deletebatchexpressdata/${id}`,method:'delete'})
}
//获取行信息
export const byIdExpressData= (id) =>{
return requests({url:`/data/express/${id}`,method:'get'})
}
//修改
export const editExpressData= (data) =>{
return requests({url:'/data/editexpress',data,method:'put'})
}

//*****************************************************************
//***************运货查价***************
//海运港口
//一次性请求海运港口下拉框数据
export const getPortBySeaSelect= () =>{
return requests({url:'/nopermission/portbyseaselect',method:'get'})
}
//多次请求海运港口下拉框数据
export const getManyTimesPortBySeaSelect= ({params}) =>{
return requests({url:'/nopermission/manytimesportbyseaselect',params,method:'get',headers:{
	'PartialNProgress':undefined
}})
}
//空运港口
//一次性请求空运港口下拉框数据
export const getAirPortSelect= () =>{
return requests({url:'/nopermission/airportselect',method:'get'})
}
//多次请求空运港口下拉框数据
export const getManyTimesAirPortSelect= ({params}) =>{
return requests({url:'/nopermission/manytimesairportselect',params,method:'get',headers:{
	'PartialNProgress':undefined
}})
}
//国际快递国家
//一次性请求国际快递国家下拉框数据
export const getExpressCountrySelect= () =>{
return requests({url:'/nopermission/expresscountryselect',method:'get'})
}
//多次请求下拉框数据
export const getManyTimesExpressCountrySelect= ({params}) =>{
return requests({url:'/nopermission/manytimesexpresscountryselect',params,method:'get',headers:{
	'PartialNProgress':undefined
}})
}
//内陆拖车下拉数据
export const getTrailerSelect = () =>{
return requests({url:'/nopermission/trailerselectquery',method:'get'})
}
//铁路下拉数据
export const getRailroadSelect = () =>{
return requests({url:'/nopermission/railroadselectquery',method:'get'})
}
//******************不需要登录，游客查价返回的数据********************
//整箱查价
export const getWholeBySeaTourists= ({params}) =>{
return requests({url:'/nopermission/touristswholebysea',params,method:'get'})
}
//海运拼箱
export const getLclBySeaQueryTourists= ({params}) =>{
return requests({url:'/nopermission/touristslclbyseaquery',params,method:'get'})
}
//内陆拖车
export const getTrailerQueryTourists= ({params}) =>{
return requests({url:'/nopermission/touriststrailerquery',params,method:'get'})
}
//铁路
export const getRailroadQueryTourists= ({params}) =>{
return requests({url:'/nopermission/touristsrailroadquery',params,method:'get'})
}
//空运
export const getByAirQueryTourists= ({params}) =>{
return requests({url:'/nopermission/touristsbyairquery',params,method:'get'})
}
//国际快递
export const getExpressQueryTourists= ({params}) =>{
return requests({url:'/nopermission/touristsexpressquery',params,method:'get'})
}

//*********************************************************************************
//用户登录了返回的价格
//海运整箱
export const getWholeBySea= ({params}) =>{
return requests({url:'/query/wholebysea',params,method:'get'})
}
//海运拼箱
export const getLclBySeaQuery= ({params}) =>{
return requests({url:'/query/lclbyseaquery',params,method:'get'})
}
//内陆拖车
export const getTrailerQuery= ({params}) =>{
return requests({url:'/query/trailerquery',params,method:'get'})
}
//铁路
export const getRailroadQuery= ({params}) =>{
return requests({url:'/query/railroadquery',params,method:'get'})
}
//空运
export const getByAirQuery= ({params}) =>{
return requests({url:'/query/byairquery',params,method:'get'})
}
//国际快递
export const getExpressQuery= ({params}) =>{
return requests({url:'/query/expressquery',params,method:'get'})
}




//*********出运委托记录*****************
export const getEntrustmentList= ({params}) =>{
return requests({url:'/my/getentrustment',params,method:'get'})
}
//********************客户点击我要订舱，提示给专属客服邮箱********************
export const sendOrderToCustomerService= ({data}) =>{
return requests({url:'/send/sendordertocustomer',data,method:'post'})
}

export const sendOrderShipmentToCustomerService= ({data}) =>{
return requests({url:'/send/sendordershipmenttocustomer',data,method:'post'})
}
//首页我要订舱
export const sendOrderTjkpToCustomerService= ({data}) =>{
return requests({url:'/send/sendordertjkptocustomer',data,method:'post'})
}
export const sendOrderTjkpShipmentToCustomerService= ({data}) =>{
return requests({url:'/send/sendordertjkpshipmenttocustomer',data,method:'post'})
}



//**********微信小程序管理***************
//获取首页信息
export const getAppHomeList= () =>{
return requests({url:'/apphomeimg/home',method:'get'})
}
//新增信息
export const addAppHomeData= ({data}) =>{
return requests({url:'/apphomeimg/home/add',data,method:'post'})
}
//根据id获取信息
export const byIdAppHome= (id) =>{
return requests({url:`/apphomeimg/home/byid/${id}`,method:'get'})
}
//根据id更新数据
export const updateByAppHome= ({data}) =>{
return requests({url:'/apphomeimg/home/update',data,method:'put'})
}
//删除数据
export const delAppHome= (id) =>{
return requests({url:`/apphomeimg/home/delete/${id}`,method:'delete'})
}





//******************************微信开放平台**********************************
//微信开放平台登录
export const reqWebLogin= (data) =>{
return requests({url:'/api/wxweblogin',data,method:'post'})
}
//获取code
export const getCode= () =>{
return requests({url:'/api/code',method:'get'})
}